import Vue from "vue";
import { newLogger } from "@/utils/util";
import network from "../../../utils/network";

let logger = newLogger("CalculationStore");

const urls = {
  calculation: (offerId, value) =>
    `/bnpl/in_store/calculation/${offerId}?value=${value}`,
};

const initState = () => {
  return {
    calculation: {},
    loading: true,
  };
};

const actions = {
  calculate: async ({ commit, rootGetters }, isB2b) => {
    try {
      let offerId = null;
      if (!isB2b) {
        offerId = rootGetters["offer/getOffer"];
      } else {
        offerId = rootGetters["offer/getB2bOffer"];
      }
      const value = rootGetters["bnplInStoreApplication/getApplicationValue"];
      if (offerId && value) {
        commit("setLoading", true);
        const axios = await network.connection();
        let { data } = await axios.get(urls.calculation(offerId, value));
        commit("saveCalculation", data);
        commit("setLoading", false);
      }
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
};

const mutations = {
  saveCalculation: (state, data) => {
    Vue.set(state, "calculation", data);
  },
  setLoading: (state, data) => {
    Vue.set(state, "loading", data);
  },
};

const getters = {
  getCalculation: (state) => {
    return state.calculation;
  },
  getLoading: (state) => {
    return state.loading;
  },
};

export default {
  namespaced: true,
  state: initState(),
  mutations: mutations,
  actions: actions,
  getters: getters,
};
